import React from 'react';

function CollectionHomeDetail(props) {
    let collection=props.collection
    return (        
        
        collection.image_position === "left" ?
        <div className="row" onClick={()=>{props.filter(null,collection.id)}} style={{cursor:"pointer",padding:"0 15px"}}>
            <div className="col-4" style={{textAlign:collection.image_position !== "left" ? "left":"right"}}>
                <img src={collection.collectionimage_set[0] ? collection.collectionimage_set[0].file:null} style={{width:"100%",maxHeight:"200px",margin:"0 auto"}} alt=""/>
            </div>
            <div className="col-8" style={{textAlign:collection.image_position === "left" ? "left":"right"}}>
                <div className="col-12 home-title-collection">
                    {collection.title}
                </div>
                <div className="col-12 home-subtitle-collection">{collection.subtitle}</div>
                <div className="col-12" dangerouslySetInnerHTML={{ __html: collection.other_info}} ></div>
            </div>
        </div>
        :
        <div className="row" onClick={()=>{props.filter(null,collection.id)}} style={{cursor:"pointer" ,padding:"0 15px"}}>
            <div className="col-8" style={{textAlign:collection.image_position === "left" ? "left":"right"}}>
                <div className="col-12 home-title-collection">
                    {collection.title}
                </div>
                <div className="col-12 home-subtitle-collection" dangerouslySetInnerHTML={{ __html: collection.subtitle}}></div>
                <div className="col-12" dangerouslySetInnerHTML={{ __html: collection.other_info}} ></div>
            </div>
            <div className="col-4" style={{textAlign:collection.image_position !== "left" ? "left":"right"}}>
                <img src={collection.collectionimage_set[0] ? collection.collectionimage_set[0].file:null} style={{maxWidth:"100%",maxHeight:"200px",margin:"0 auto"}} alt="" alt=""/>
            </div>
        </div>
    );
}

export default CollectionHomeDetail;